import React, { useEffect, useState } from 'react';
import { Table } from '@/components/Elements';
import { User } from '@/types';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { Button, MenuItem, MenuList } from '@mui/material';
import i18next from 'i18next';
import del from '@/assets/del.svg';
import eye from '@/assets/view.svg';
import '../routes/Dashboard.css';
import Modal from 'react-responsive-modal';
import close from '@/assets/close-circle.svg';
import delet from '@/assets/delet.svg';
const HelpTable = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleModal = () => {
    setOpen(false);
    onOpenModal();
  };
  useEffect(() => {});

  const staticData = [
    {
      ticket_name: 'Lorem ipsum',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ornare gravida est. ',
      date: '12-03-2024',
      time: '12:41:20 pm',
      amount: '$200',
      status: 'accepted',
      action: '',
    },
    {
        ticket_name: 'Lorem ipsum',
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras ornare gravida est. ',
        date: '12-03-2024',
        time: '12:41:20 pm',
        amount: '$200',
        status: 'accepted',
        action: '',
      },
  ];

  const toggleMenu = () => setOpen(!open);

  return (
    <>
      <div className="inquiry-filters">
        <div className="admin-cards">
          <div className="d-flex justify-between items-center">
            <h4 className="f-18 font-semibold mb-0 request-title">Help and Support</h4>
            <Button className="pink-btn">Add Ticket</Button>
          </div>
          <BackdropLoader open={loading} />

          <Table<User>
            page={1}
            //   changePage={changePage}
            total={staticData.length}
            data={staticData}
            columns={[
              { title: 'Ticket Name', field: 'ticket_name' },
              { title: `Ticket Description`, field: 'description' },
              { title: 'Date', field: 'date' },
              { title: `Time`, field: 'time' },

              {
                title: `${i18next.t('Status')}`,
                field: 'status',
                Cell: (row) => <span className="Accepted">Resolved</span>,
              },
              {
                title: 'Action',
                field: 'action',
                Cell: () => (
                  <div className="action-filters">
                    <Button
                      variant="contained"
                      onClick={handleModal}
                      className="bg-transparent border-0 px-0 py-0  shadow-none text-black f-18"
                    >
                      <img src={del} className="del-ico" />
                    </Button>
                    <Button
                      variant="contained"
                      className="bg-transparent border-0  px-0 py-0 shadow-none text-black f-18"
                    >
                      <img src={eye} className="del-ico" />
                    </Button>
                  </div>
                ),
              },
            ]}
          />
        </div>
        <div className="agency-modal del">
          <Modal open={open} onClose={onCloseModal} center>
            <button
              className="modal-close-button"
              onClick={onCloseModal}
              aria-label="Close"
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                background: 'none',
                border: 'none',
                fontSize: '40px',
                cursor: 'pointer',
              }}
            >
              <img src={close} className="close-circle" />
            </button>
            <section className=" ticket-model">
                <img src={delet} className='delete-help m-auto' alt='' />
              <h5 className="agency-title text-center semi-bold text-black">Are you sure want to delete this Ticket?</h5>
            </section>
            <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-center">
              <Button variant='outlined' className="rounded-full cancel-btn"> Cancel</Button>
              <Button className="rounded-full pink-btn"> Delete</Button>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default HelpTable;
